exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../TextInput/text-input.css"), undefined);
exports.i(require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/typography.css"), undefined);

// module
exports.push([module.id, "._19vl5QDYoWf7Vf8J48wncz {\n  font-weight: 500;\n  font-family: \"sofia-pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  box-sizing: border-box;\n}\n._19vl5QDYoWf7Vf8J48wncz {\n\n  margin-bottom: 0;\n}\n", ""]);

// exports
exports.locals = {
	"input": "_19vl5QDYoWf7Vf8J48wncz " + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../TextInput/text-input.css").locals["input"] + " " + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/typography.css").locals["base1"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/ApplicationForm/input.css
 ** module id = 440
 ** module chunks = 0
 **/